import { CapacityEnum } from "~/types/event/eventEnums.type";

export const capacityToNames: { [key in CapacityEnum]: string } = {
  FROM_1_TO_25: "1 → 25",
  FROM_25_TO_120: "25 → 120",
  FROM_120_TO_250: "120 → 250",
  FROM_250_TO_500: "250 → 500",
};

export const numberToCapacity = (cap: number) => {
  if (cap <= 25) {
    return CapacityEnum.FROM_1_TO_25;
  } else if (cap <= 120) {
    return CapacityEnum.FROM_25_TO_120;
  } else if (cap <= 250) {
    return CapacityEnum.FROM_120_TO_250;
  } else {
    return CapacityEnum.FROM_250_TO_500;
  }
};

export const compareCapacity = (a: CapacityEnum, b: CapacityEnum) => {
  const aCap = parseInt(a.split("_")[1]);
  const bCap = parseInt(b.split("_")[1]);
  return aCap <= bCap;
};
export const capacities: CapacityEnum[] = [
  CapacityEnum.FROM_1_TO_25,
  CapacityEnum.FROM_25_TO_120,
  CapacityEnum.FROM_120_TO_250,
  CapacityEnum.FROM_250_TO_500,
];
